import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const ItemsFooterWrapper = styled.footer`
    display: inline-grid;
    grid-template-columns: 1fr auto 1fr;
    column-gap: 0.5rem;
    width: 100%;
    margin-top: 3rem;
    margin-bottom: 2rem;

    > * {
        align-self: center;
    }

    > :nth-of-type(3) {
        margin-left: auto;
    }
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 1rem 0 0 0;
    min-width: 180px;
    max-width: 240px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

